/**
 * Whether the device is driven by a finger rather than a mouse.
 *
 * HTML5 drag-and-drop is a mouse affordance. On a touch screen Blink spends
 * the long-press gesture on starting a drag whenever the pressed element is
 * `draggable` (`EventHandler::HandleGestureLongPress` →
 * `HandleDragDropIfPossible`), and never fires `contextmenu` — so every
 * long-press context menu that sits on a draggable element is unreachable on
 * a phone. Dragging a file out of a browser tab, or reordering profiles with
 * a finger, is not something this app can do anyway, so `draggable` is simply
 * switched off there.
 *
 * ponytail: reads the *primary* pointer, so a laptop with both a mouse and a
 * touch screen keeps dragging (and keeps long-press broken). Upgrade path if
 * that ever matters: decide per gesture from `pointerType` on `pointerdown`.
 */
export function isCoarsePointer(): boolean {
  return window.matchMedia('(pointer: coarse)').matches
}
